import { EffectOptions } from '../app';
import { updateProductAccess } from '../app/state/app.actions';
import {
    AppActions, UPDATE_SELECTED_PRODUCT
} from '../app/state/app.types';
import { ROUTES } from '../routes';
import { selectHasProductAccess } from '../user-profiles';

export function productSelectorEffects ({
    action, context, getState, dispatch
}: EffectOptions<AppActions>) {
    /**
     * When the current product is switched, redirect to the welcome route
     * and update the current product licence access state.
     */
    if (action.type === UPDATE_SELECTED_PRODUCT) {
        const state = getState();
        const hasProductAccess = selectHasProductAccess(
            state,
            action.payload.productId
        );

        dispatch(updateProductAccess(hasProductAccess));
        context.history.push(ROUTES.welcome);
    }
}
